// NOTE: I don't know what default means here
import {BaseCurrencyCode} from '@raison/types';
import {createAction} from '@reduxjs/toolkit';
import {Assets} from '~/shared/api/legacy_services/Assets/Assets';
import {appLocalStorage} from '~/shared/persistence';

export const assetsRequestRoutine = (type => ({
    aborted: createAction(`${type}/ABORTED`),
    trigger: createAction(`${type}/TRIGGER`),
    success: createAction(`${type}/SUCCESS`, (data: Assets) => ({payload: data})),
    failure: createAction(`${type}/FAILURE`, (error: unknown) => ({payload: error})),
}))('ASSETS_REQUEST' as const);

export const getAssetsAndMarketplace = () => (dispatch: AppDispatch) => {
    dispatch(assetsRequestRoutine.trigger());
};

export const setCurrentCurrency = createAction('default/setBallanceCurrency', (currency: BaseCurrencyCode) => {
    appLocalStorage.balanceCurrency.set(currency);
    return {
        payload: currency,
    };
});
